export const SET_CURRENT_SECTION = "SET_CURRENT_SECTION";
export const SET_CURRENT_SECTION_INDEX = "SET_CURRENT_SECTION_INDEX";
export const ADJUST_DRILLED_DOWN_COUNT_BY = "ADJUST_DRILLED_DOWN_COUNT_BY";
export const REMOVE_CURRENT_SECTION = "REMOVE_CURRENT_SECTION";
export const SHOW_CORRECT_ANSWER = "SHOW_CORRECT_ANSWER";
export const STORE_AUTO_SELECTED = "STORE_AUTO_SELECTED";
export const SET_IS_SUBMIT_CLICKED = "SET_IS_SUBMIT_CLICKED";
